import React from 'react'
import { Text } from '@chakra-ui/react'
import { Tooltip } from '@chakra-ui/react'
import { useMessageProperties } from '../message-provider'
import { formatHumanReadableDate } from '../message-helpers'
import { formatDistanceToNowStrict } from 'date-fns'

export default function ChatTimestamp() {
    const { message } = useMessageProperties()
    const isIncoming = message.client

    return (
        <Tooltip
            label={`${isIncoming ? 'Received' : 'Sent'} ${formatHumanReadableDate(message.created_at)}`}
            hasArrow
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
            rounded="lg"
        >
            <Text
                noOfLines={1}
                fontSize="12px"
                minW="fit-content"
                color="blackAlpha.500"
            >
                {getTimestamp(message.created_at)}
            </Text>
        </Tooltip>
    )
}

function getTimestamp(lastMessageTime: number) {
    const distanceParts = formatDistanceToNowStrict(lastMessageTime).split(' ')

    return `${distanceParts[0]}${TimeUnitMap[distanceParts[1] as keyof typeof TimeUnitMap] ?? 'N/A'}`
}

const TimeUnitMap = {
    second: 's',
    seconds: 's',
    minute: 'm',
    minutes: 'm',
    hour: 'h',
    hours: 'h',
    day: 'd',
    days: 'd',
    week: 'w',
    weeks: 'w',
    month: 'mo',
    months: 'mo',
    year: 'y',
    years: 'y',
}
